const cookieConsentInit = () => {
    const hasConsent = () => {
        try {
            return window.localStorage.getItem('cookie-consent') === 'accepted';
        } catch(e) {
            return false;
        }
    }

    const setConsent = () => {
        try {
            window.localStorage.setItem('cookie-consent', 'accepted');
        } catch(e) {}
    }

    const cookieConsentElement = document.querySelector('.cookie-consent');

    if (!cookieConsentElement) {
        return;
    }

    const cookieConsentButtonElement = cookieConsentElement.querySelector('button');

    if (!cookieConsentButtonElement) {
        return;
    }

    cookieConsentButtonElement.addEventListener('click', () => {
        setConsent();
        cookieConsentElement.setAttribute('hidden', '');
    });

    if (!hasConsent()) {
        cookieConsentElement.removeAttribute('hidden');
    }
}

export default cookieConsentInit;